<template>
  <div>
    <EmbedMedia
      :id="embedId"
      :source="sourceValue"
      :aspect-ratio="aspectRatio"
      :aspect-ratio-mobile="aspectRatioMobile"
    />
  </div>
</template>

<script>
import EmbedMedia from '../elements/EmbedMedia.vue'

export default {
  components: { EmbedMedia },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    embedId () {
      return this.value?.content?.find(el => el.key === 'embed')?.value || ''
    },
    sourceValue () {
      return this.value?.content?.find(el => el.key === 'embed')?.options.find(opt => opt.key === 'source')?.value || ''
    },
    aspectRatio () {
      return this.value?.options?.find(el => el.key === 'aspectRatio')?.value
    },
    aspectRatioMobile () {
      return this.value?.options?.find(el => el.key === 'aspectRatioMobile')?.value
    }
  }
}
</script>
